import * as Api from '../../api/api';

export const validateAreaCode = async (areaCode: string): Promise<boolean> =>
  Api.get(`/twilio/validate-area-code/${areaCode}`)
    .then((r) => r.json())
    .then((data) => data.isValid);
